import { FormState } from "./types";

export const INITIAL_FORM_STATE: FormState = {
  componentFields: {},
  componentFieldErrors: {},
  componentFieldMessages: {},
  parentComponentFields: {},
  parentComponentFieldErrors: {},
  parentComponentId: null,
  parentDropdownOptions: [],
  treeItems: [],
  expandedIds: new Set(),
  editingItemId: null,
};

